import { companiesCompanyIdEmailSelfServeConfigurationData } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdEmailSelfServeSendingDomainDomainIdTrackingDomainCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdEmailSelfServeConfigurationData,
];
